import { render, staticRenderFns } from "./TownsStreetsMonthServiceElderCharityDonation.vue?vue&type=template&id=68af5c40&scoped=true&"
import script from "./TownsStreetsMonthServiceElderCharityDonation.vue?vue&type=script&lang=js&"
export * from "./TownsStreetsMonthServiceElderCharityDonation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68af5c40",
  null
  
)

export default component.exports